export default __webpack_public_path__ + "static/media/aurelia.ee477f21.svg";